const poboxDialogTemplate = [
    {
        title: 'Customer',
        fields: [
            {
                label: 'Number',
                component: 'VTextField',
                model: 'customer.number'
            },
            {
                label: 'Name',
                component: 'VTextField',
                model: 'name',
                required: true,
                rules: 'required'
            },
            {
                label: 'Last Name',
                component: 'VTextField',
                model: 'lastname'
            },
            {
                label: 'ID Document',
                component: 'VTextField',
                model: 'docid',
                readonly: true
            },
            {
                label: 'Email',
                component: 'VTextField',
                model: 'email',
                rules: 'email|required',
                required: true
            },
            {
                label: 'Phone No.',
                component: 'VTextField',
                model: 'phone'
            },
            {
                label: 'Mobile Phone No.',
                component: 'VTextField',
                model: 'mobile'
            },
            {
                label: 'Agency',
                component: 'AgencyFilter',
                model: 'agency',
                returnObject: true,
                required: true,
                rules: 'required'
            },
            {
                label: 'Agent',
                component: 'AgentFilter',
                model: 'agent',
                returnObject: true
            },
            {
                label: 'Group Tariff',
                component: 'GroupTariffFilter',
                model: 'groupTariff',
                returnObject: true
            },
            {
                label: 'Location',
                component: 'LocationFilter',
                model: 'location',
                returnObject: true
            },
            {
                label: 'Company',
                component: 'VSwitch',
                initialValue: false,
                model: 'customerType'
            }
        ]
    },
    {
        title: 'Address',
        fields: [
            {
                label: 'Address',
                component: 'VTextField',
                model: 'address',
                required: true,
                rules: 'required'
            },
            {
                label: 'City',
                component: 'City',
                model: 'city',
                returnObject: true,
                required: true,
                rules: 'required'
            },
            {
                label: 'State',
                disabled: true,
                component: 'VTextField',
                model: 'state'
            },
            {
                label: 'Zip Code',
                component: 'VTextField',
                model: 'zip'
            },
            {
                label: 'Country',
                disabled: true,
                component: 'VTextField',
                model: 'country'
            }
        ]
    },
    {
        title: 'Username',
        fields: [
            {
                label: 'Username',
                visible: true,
                component: 'VTextField',
                model: 'username',
                initialValue: null,
                required: true,
                rules: 'required'
            }
        ]
    },
    {
        title: 'Password',
        fields: [
            {
                label: 'Password',
                component: 'PasswordField',
                model: 'password',
                required: true,
                rules: 'required'
            },
            {
                label: 'Repeat password',
                component: 'PasswordField',
                model: 'passwordRepeat',
                required: true,
                rules: 'confirmed:@password'
            }
        ]
    }
];

export default poboxDialogTemplate;
